/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Tim Porritt
 * Created: 11/11/21
 */

import { withDisplayName } from './withDisplayName';
import React, { ComponentType } from 'react';

export const namedMemo = <T>(
    displayName: string,
    Component: ComponentType<T>,
    equality?: Parameters<typeof React.memo>[1],
) => React.memo(withDisplayName(Component, displayName), equality);
